import {
  type OutgoingInvoice,
  useOutgoingInvoiceQuery,
} from "@src/__generated__/graphql";
import { Spinner } from "@src/components/ui-kit";
import { useStore } from "@src/utils/hooks";
import { FormMode } from "@src/utils/types";
import { observer } from "mobx-react-lite";
import { type FC, useEffect, useState } from "react";
import { Container } from "../components";
import {
  InvoiceStore,
  InvoiceStoreContext,
  InvoiceTypeEnum,
  InvoiceTypeEnumFrom,
} from "../store";

type DuplicateOutgoingInvoiceProps = {
  id: OutgoingInvoice["id"];
};

const INVOICE_TYPE = InvoiceTypeEnum.Outgoing;

export const DuplicateOutgoingInvoice: FC<DuplicateOutgoingInvoiceProps> =
  observer(function DuplicateOutgoingInvoice({ id }) {
    const appStore = useStore();
    const [store] = useState(
      () => new InvoiceStore(appStore, true, INVOICE_TYPE, FormMode.DUPLICATE),
    );

    const { data, loading } = useOutgoingInvoiceQuery({ variables: { id } });

    useEffect(() => {
      if (!data?.outgoingInvoice) return;
      store.type = InvoiceTypeEnumFrom(data.outgoingInvoice.type);
      store.duplicate(data.outgoingInvoice);
    }, [data?.outgoingInvoice]);

    if (loading) {
      return <Spinner absolute />;
    }

    return (
      <InvoiceStoreContext.Provider value={store}>
        <Container />
      </InvoiceStoreContext.Provider>
    );
  });
